export enum paths {
  EXPLORE = '/explore',
  ABOUT = '/about',
}